export const routes = (prefix = `radiology`) => [
    {
        path: `/${prefix}/patients`,
        name: `${prefix}.patients.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patients.index`,
                PageDescription: "Radiology: Patient queue",
            },
        },
    },
    {
        path: `/${prefix}/patients-print`,
        name: `${prefix}.patients-print.index`,
        component: () => import('../prints/Queue.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patients.index`,
                PageDescription: "Radiology: Patient queue",
            },
        },
    },
    {
        path: `/${prefix}/patients-round-report-print`,
        name: `${prefix}.patients-round-report-print.index`,
        component: () => import('../prints/RoundReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.patients.index`,
                PageDescription: "Radiology: Patient queue",
            },
        },
    },
];